<!-- Spacer -->
<div
    class="devstroupe-vertical-navigation-item-wrapper"
    [ngClass]="item.classes?.wrapper"></div>
